export const enum HistoryRequestType {
    Older = 'OLDER',
    Newer = 'NEWER',
    OlderAndNewer = 'OLDER_AND_NEWER',
}
